export const QUERY_KEYS = {
  FEED_KEY: "feed",
  ALL_SUBS_KEY: "useAllSubmissions",
  LAST_5_SUBS_KEY: "last5Submissions",
  LAST_10_SUBS_KEY: "last10Submissions",
  ALL_COMPLETIONS_KEY: "submissions",
  USER_DATA: "users",
  PROFILE: "profile",
  TEAM_LOCATIONS: "teamlocations",
  TEAM_ROLES: "companyRoles",
  TEAMS: "teams",
  COMPLETION_DETAILS: "submissionDetail",
  BADGE_DETAIL: "badgeDetails",
  ALL_BADGES: "badges",
  LEADERBOARD: "leaderboard",
  MODULE_DETAILS: "moduleDetails",
  MODULE_INFO: "moduleInfo",
  COUNTRIES: "countries",
  VERTICALS: "verticals",
  REFERRAL_CODE: "referralCode",
  STATES: "states",
  CERT_DETAIL: "certDetails",
  NOT_FOLLOWED_COMPANIES: "availToFollow",
  FOLLOWED_COMPANIES: "followingCompanies",
  COMPANY_DETAILS: "companyDetails",
  SUGGESTED_BRANDS: "suggestedBrands",
};
